import React from 'react';

export enum PanelTheme {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
    Yellow = 'yellow',
}

export enum PanelBorderStyle {
    None = 'noBorder',
    Solid = 'solidBorder',
}

export enum PanelBorderRadius {
    None = 'noRadius',
    Small = 'smallRadius',
    Medium = 'mediumRadius',
}

export const Panel: React.FC<{
    children: any;
    theme: PanelTheme;
    width?: string;
    height?: string;
    padding?: number;
    borderStyle?: string;
    borderRadius?: string;
    handleClick?: React.MouseEventHandler;
}> = ({
    children,
    theme,
    width = 'auto',
    height = 'auto',
    padding = 'auto',
    borderStyle = PanelBorderStyle.None,
    borderRadius = PanelBorderRadius.None,
    handleClick,
}) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
        padding: `${padding}px`,
        cursor: `${!handleClick ? 'arrow' : 'pointer'}`,
    };

    return (
        <>
            <div
                className={`panel ${theme} ${borderStyle} ${borderRadius}`}
                style={setStyle}
                onClick={handleClick}
            >
                {children}
            </div>
        </>
    );
};
